<template>
  <AgGridRenderList
    :columnDefs="columnDefs"
    :rowData="rowData"
    :totalRows="totalRows"
    :lastPage="lastPage"
    :loading="paginationLoading"
    @selection-changed="onSelectionChanged"
    @updatePagination="updatePagination"
    @updateItemPerPage="updateItemPerPage"
  />
</template>

<script>
import General from "../../../../../../Mixins/general";
import moment from "moment-jalaali";
moment.loadPersian({ dialect: "persian-modern" });

export default {
  components: {},
  props: {
    callRefresh: {
      type: Boolean,
      default: false,
    },
    callDelete: {
      type: Boolean,
      default: false,
    },
    callGroupDelete: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIds: [],
      rowObject: null,
      columnDefs: null,
      rowData: null,
      totalRows: null,
      lastPage: null,
      invoiceIds: null,
      filterDialog: false,
      toDate: null,
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      account: null,
      sellStatus: null,
      currencyFilter: null,
      fromAmount: null,
      fromNumber: null,
      fromDate: null,
      toAmount: null,
      toNumber: null,
      toDate: null,
      tag: null,
      category: null,
      branch: null,
      entrepot: null,
      lockStatus: null,
      registerar: null,
      payedStatus: null,
      fromTime: null,
      toTime: null,
      customFields: null,
      workshopName: null,
      personnelName: null,
      paginationLoading: false,
    };
  },
  mixins: [General],
  mounted() {
    this.columnDefs = [
      {
        headerName: "",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 50,
        maxWidth: 50,
        minWidth: 50,
        cellRenderer: "AgVMenu",
        cellRendererParams: (params) => ({
          items: [
            {
              label: this.$t("Print_contract"),
              icon: "mdi-printer-outline",
              iconColor: "gray",
              action: (rowData) => this.print(rowData),
            },
            {
              label: this.$t("edit"),
              icon: "mdi-pencil",
              iconColor: "gray",
              action: (rowData) => this.editAction(rowData),
            },
            {
              label: this.$t("delete"),
              icon: "mdi-trash-can-outline",
              iconColor: "gray",
              action: (rowData) => this.deleteActionPermission(rowData),
            },
          ],
        }),
        resizable: false,
        pinned: "right",
      },
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 50,
        maxWidth: 50,
        minWidth: 50,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: this.$t("start-date"),
        field: "start_date",
        // filter: "agTextColumnFilter",
        valueFormatter: (params) => this.toJalali(params.value),
        filterParams: {
          closeOnApply: true,
          buttons: ["apply", "reset"],
          debounceMs: 0,
        },
        minWidth: 590,
        maxWidth: 600,
        sortable: true,
      },
      {
        headerName: this.$t("end-date"),
        field: "end_date",
        valueFormatter: (params) => this.toJalali(params.value),
        minWidth: 590,
        maxWidth: 600,
        sortable: true,
      },
    ];
  },
  watch: {
    callGroupDelete: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.deletegroupAction();
        }
      },
    },
    callDelete: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.deleteAction();
        }
      },
    },
    callRefresh: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.getItems();
          this.$emit("initial-Loading-is", false);
        }
      },
    },
  },
  beforeMount() {
    this.getItems();
  },
  methods: {
    onSelectionChanged(rows) {
      const ids = rows.map((r) => r.id);
      if (ids.length > 1) {
        this.selectedIds = ids;
        this.$emit("group-delete", true);
        return;
      }
      this.selectedIds = [];
      this.$emit("group-delete", false);
    },
    getItems(isPaginate = false) {
      var app = this;
      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }
      this.paginationLoading = isPaginate;
      app.$axios
        .get(app.$endpoint + "salary-commitment", {
          params: {
            options: app.optionsNew,
            employee_id: this.$route.params.id,
          },
        })
        .then((response) => {
          app.personnelName = response.data.employee.user.name;
          app.workshopName = response.data.employee?.workshop?.name || null;
          app.rowData = [...response.data.salaryCommitments.data];
          app.totalRows = response.data.salaryCommitments.total;
          app.lastPage = response.data.salaryCommitments.last_page;
          app.$emit("workshop-items", {
            items: response.data,
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    refreshData() {
      this.getItems(true);
    },
    updatePagination(value) {
      this.optionsNew.page = value;
      this.getItems(true);
    },
    updateItemPerPage(value) {
      this.optionsNew.itemsPerPage = value;
      this.optionsNew.page = 1;
      this.getItems(true);
    },
    toJalali(date) {
      if (!date) return this.$t("haveNot");
      const m = moment(date);
      if (!m.isValid()) {
        console.warn("Invalid date received:", date);
        return this.$t("haveNot");
      }
      return m.format("jYYYY/jMM/jDD");
    },
    editAction(rowData) {
      this.$router.push({
        name: "commandments_edit",
        query: {
          rowId: encodeURIComponent(rowData.id),
          id: encodeURIComponent(rowData.hrm_employee_id),
          employeeName: encodeURIComponent(this.personnelName),
          name: encodeURIComponent(this.workshopName),
        },
      });
    },
    deleteActionPermission(rowData) {
      this.$emit("open-dialog-permision", true);
      this.rowObject = rowData;
    },
    deleteAction() {
      var app = this;
      if (!app.rowObject?.id) {
        app.$emit("close-dialog-permision");
        return;
      }
      let commandmentsId = app.rowObject.id;
      app.$axios
        .delete(app.$endpoint + "salary-commitment/" + commandmentsId)
        .then(() => {
          app.$emit("close-dialog-permision");
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("close-dialog-permision");
          this.getItems(true);
          app.paginationLoading = false;
        });
    },
    deletegroupAction() {
      var app = this;
      let ids = app.selectedIds;
      app.$axios
        .delete(app.$endpoint + "salary-commitment/0", {
          params: { deleteItems: ids },
        })
        .then(() => {
          app.selectedIds = [];
          app.$emit("close-dialog-permision");
          app.getItems(true);
        })
        .catch((err) => {
          app.$emit("close-dialog-permision");
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.selectedIds = [];
          app.$emit("close-dialog-permision");
          app.getItems(true);
          app.paginationLoading = false;
        });
    },
    print(rowData) {
      this.$router.push({
        name: "contract_print",
        query: { id: rowData.id },
      });
    },
  },
};
</script>

<style>
.wrapperTable {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.v-skeleton-loader__list-item.v-skeleton-loader__bone {
  align-content: unset;
  align-items: flex-start;
  padding: 0;
}
.theme--light.v-skeleton-loader .v-skeleton-loader__text {
  background: rgb(146 139 139 / 12%);
}
.v-skeleton-loader__text {
  height: 30px;
}
.v-skeleton-loader__list-item {
  height: 41px;
}
</style>
